import produce from 'immer';

import {
    JUMIO_SET_HAVE_COPY_ID_FAX,
    JUMIO_SET_UPLOAD_REQUIREMENT
} from './actions';

export const defaultState = {};

export const reducer = (reducerSuffix) => produce((draftState, action) => {
    switch (action.type) {
        case JUMIO_SET_UPLOAD_REQUIREMENT:
        case JUMIO_SET_UPLOAD_REQUIREMENT + reducerSuffix: {
            draftState.uploadRequirement = action.payload;

            break;
        }

        case JUMIO_SET_HAVE_COPY_ID_FAX:
        case JUMIO_SET_HAVE_COPY_ID_FAX + reducerSuffix: {
            draftState.haveCopyIDFax = action.payload;

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
